import { type MouseEventHandler } from 'react';
import history from 'utils/history';
import { trackEvent, GACommonEventAction, GAEventCategory } from 'services/googleAnalytics';
import { BackButton } from 'components';

export type HistoryBackButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

const HistoryBackButton = ({onClick, ...props} : HistoryBackButtonProps) : JSX.Element => {
  
  const handleHistoryBack = () => {
    trackEvent(GAEventCategory.BUTTON, GACommonEventAction.CLICK, 'Retour');
    history.goBack();
  };

  return <BackButton data-testid="history-back-button" onClick={onClick || handleHistoryBack} {...props} />;
};

export default HistoryBackButton;